var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeleteIcon = function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13.33,
    height: 16.67,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 6.50001V15.6667H11.1667V6.50001H12.8333V16.5C12.8333 16.9602 12.4602 17.3333 12 17.3333H1.99999C1.53976 17.3333 1.16666 16.9602 1.16666 16.5V6.50001H2.83333ZM6.16666 6.50001V14H4.49999V6.50001H6.16666ZM9.49999 6.50001V14H7.83333V6.50001H9.49999ZM9.49999 0.666672C9.85869 0.666672 10.1771 0.896197 10.2906 1.23648L10.9333 3.16584L13.6667 3.16667V4.83334H0.333328V3.16667L3.06583 3.16584L3.70942 1.23648C3.82285 0.896197 4.1413 0.666672 4.49999 0.666672H9.49999ZM8.89936 2.33334H5.10063L4.82249 3.16584H9.17666L8.89936 2.33334Z",
    fill: "#DF2020"
  })));
};
export { SvgDeleteIcon as ReactComponent };
export default __webpack_public_path__ + "assets/2c8b7f35.svg";